import { useNavigate } from "react-router-dom";
import { useEnableReveal } from "@/lib/useReveal";
import { Nav } from "@/components/ui/Nav";
import { Footer } from "@/components/ui/Footer";
import { Trilhas } from "@/components/home/Trilhas";
import { Resultados } from "@/components/home/Resultados";

export default function TrilhasPage() {
  useEnableReveal();
  const navigate = useNavigate();
  const goFunnel = () => navigate("/agendar/contato");
  const goHome = () => navigate("/");

  return (
    <>
      <Nav onCTA={goFunnel} onHome={goHome} />
      <main className="page-enter info-page">
        <Trilhas onCTA={goFunnel} />
        <Resultados onCTA={goFunnel} />
      </main>
      <Footer onCTA={goFunnel} onHome={goHome} />
    </>
  );
}
